/**
 * The type of activity.
 *
 * @remarks Currently, m2c2kit has only Game and Survey activities.
 */
export enum ActivityType {
  Game = "Game",
  Survey = "Survey",
}
